<div class="admin-shell">
  <header class="admin-nav" [class.is-mobile-open]="mobileOpen">
    <div class="admin-nav__inner">
      <a class="admin-brand" routerLink="/admin/dashboard" (click)="mobileOpen = false">
        <span class="admin-brand__mark" aria-hidden="true">
          <i class="pi pi-heart-fill"></i>
        </span>
        <span class="admin-brand__text">
          <span class="admin-brand__name">Dr. Bhade</span>
          <span class="admin-brand__tag">Homeopathy Clinic</span>
        </span>
      </a>

      <nav class="admin-nav__links" aria-label="Primary">
        @for (menu of menus; track menu.title; let i = $index) {
          @if (menu.items?.length) {
            <div
              class="admin-nav__item"
              [class.is-open]="isMenuOpen(menu, i)"
              [class.is-active]="isItemActive(menu)"
            >
              <button
                type="button"
                class="admin-nav__trigger"
                [attr.aria-expanded]="isMenuOpen(menu, i)"
                (click)="toggleMenu(menu, i, $event)"
              >
                <i class="pi" [ngClass]="menu.icon || 'pi-circle'"></i>
                <span>{{ menu.title }}</span>
                <i class="pi pi-angle-down admin-nav__caret"></i>
              </button>

              <div class="admin-nav__dropdown" role="menu">
                @for (child of menu.items; track child.path) {
                  <a
                    class="admin-nav__dropdown-link"
                    role="menuitem"
                    [routerLink]="child.path"
                    routerLinkActive="is-active"
                    (click)="closeAllOverlays()"
                  >
                    <i class="pi" [ngClass]="child.icon || 'pi-arrow-right'"></i>
                    <span>{{ child.title }}</span>
                  </a>
                }
              </div>
            </div>
          } @else if (menu.path) {
            <a
              class="admin-nav__link"
              [routerLink]="menu.path"
              routerLinkActive="is-active"
              [class.is-active]="isItemActive(menu)"
            >
              <i class="pi" [ngClass]="menu.icon || 'pi-circle'"></i>
              <span>{{ menu.title }}</span>
            </a>
          }
        }
      </nav>

      <div class="admin-nav__actions">
        <!-- Chat button is commented out on the prescription and appointment screens. -->
        <div class="admin-nav__chat" *ngIf="showDeskChatButton" [class.is-open]="deskChatOpen">
          <app-desk-chat-panel
            [open]="deskChatOpen"
            (openChange)="onDeskChatOpenChange($event)"
          />
        </div>
        <div class="admin-nav__notify" [class.is-open]="notificationsOpen">
          <app-notifications-panel
            [open]="notificationsOpen"
            (openChange)="onNotificationsOpenChange($event)"
            (closed)="notificationsOpen = false"
          />
        </div>

        <div class="admin-nav__user">
          <div class="admin-user-chip">
            <span class="admin-user-chip__avatar">{{ userInitials }}</span>
            <span class="admin-user-chip__meta">
              <span class="admin-user-chip__name">{{ userName }}</span>
              <span class="admin-user-chip__role">{{ userRoleLabel }}</span>
            </span>
          </div>
          <button
            type="button"
            class="admin-logout-btn"
            aria-label="Sign out"
            title="Sign out"
            (click)="logout()"
          >
            <i class="pi pi-sign-out"></i>
            <span>Logout</span>
          </button>
        </div>

        <button
          type="button"
          class="admin-icon-btn admin-nav__burger"
          [attr.aria-expanded]="mobileOpen"
          aria-label="Toggle navigation"
          (click)="toggleMobile()"
        >
          <i class="pi" [ngClass]="mobileOpen ? 'pi-times' : 'pi-bars'"></i>
        </button>
      </div>
    </div>

    <div class="admin-mobile" [class.is-open]="mobileOpen">
      <nav class="admin-mobile__nav" aria-label="Mobile">
        @for (menu of menus; track menu.title; let i = $index) {
          @if (menu.items?.length) {
            <div class="admin-mobile__group" [class.is-open]="isMenuOpen(menu, i) || isItemActive(menu)">
              <button type="button" class="admin-mobile__group-btn" (click)="toggleMenu(menu, i, $event)">
                <span>
                  <i class="pi" [ngClass]="menu.icon || 'pi-circle'"></i>
                  {{ menu.title }}
                </span>
                <i class="pi pi-angle-down"></i>
              </button>
              <div class="admin-mobile__children">
                @for (child of menu.items; track child.path) {
                  <a
                    [routerLink]="child.path"
                    routerLinkActive="is-active"
                    (click)="mobileOpen = false"
                  >
                    {{ child.title }}
                  </a>
                }
              </div>
            </div>
          } @else if (menu.path) {
            <a
              class="admin-mobile__link"
              [routerLink]="menu.path"
              routerLinkActive="is-active"
              (click)="mobileOpen = false"
            >
              <i class="pi" [ngClass]="menu.icon || 'pi-circle'"></i>
              {{ menu.title }}
            </a>
          }
        }
      </nav>
    </div>
  </header>

  <main class="admin-main">
    <router-outlet />
  </main>
</div>
